import { render, staticRenderFns } from "./orderStatementsTable.vue?vue&type=template&id=a086e51e&"
import script from "./orderStatementsTable.vue?vue&type=script&lang=ts&"
export * from "./orderStatementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports